import { createFileRoute } from '@tanstack/react-router';
import { InboxPage } from '@/features/inbox/pages/inbox-page';

export const Route = createFileRoute('/_app/inbox')({
  // `thread` = the open conversation (the bell, push and LINE alert link straight to it)
  validateSearch: (s: Record<string, unknown>): { thread?: string } => ({
    thread: typeof s.thread === 'string' ? s.thread : undefined,
  }),
  component: InboxPage,
});
